import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FilterDataService {
  private readonly filterData: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  filterData$: Observable<boolean> = this.filterData.asObservable();

  setFilterData(data: any): void {
    this.filterData.next(data);
  }
}
